package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Heard Island and McDonald Islands Flag (20x15dp)
 *
 * - ISO Alpha-2: HM
 * - ISO Alpha-3: HMD
 * - ISO Numeric: 334
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.HeardIslandAndMcdonaldIslands: ImageVector by lazy {
    ImageVector.Builder(
        name = "Heard Island and McDonald Islands:HM:HMD:334:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(11f)
                verticalLineToRelative(9f)
                horizontalLineToRelative(-11f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(11f)
                verticalLineToRelative(9f)
                horizontalLineToRelative(-11f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-1.253f, 8.125f)
                lineTo(1.223f, 9.211f)
                lineTo(11.306f, 1.18f)
                lineTo(12.612f, -0.433f)
                lineTo(9.965f, -0.796f)
                lineTo(5.852f, 2.665f)
                lineTo(2.542f, 4.996f)
                lineTo(-1.253f, 8.125f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-0.914f, 8.886f)
                lineTo(0.347f, 9.516f)
                lineTo(12.143f, -0.583f)
                horizontalLineTo(10.372f)
                lineTo(-0.914f, 8.886f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(12.503f, 8.125f)
                lineTo(10.306f, 9.521f)
                lineTo(-0.056f, 1.18f)
                lineTo(-1.362f, -0.433f)
                lineTo(1.285f, -0.796f)
                lineTo(5.398f, 2.665f)
                lineTo(8.708f, 4.996f)
                lineTo(12.503f, 8.125f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(12.418f, 8.671f)
                lineTo(11.157f, 9.301f)
                lineTo(6.134f, 4.977f)
                lineTo(4.645f, 4.494f)
                lineTo(-1.488f, -0.427f)
                horizontalLineTo(0.283f)
                lineTo(6.413f, 4.377f)
                lineTo(8.041f, 4.957f)
                lineTo(12.418f, 8.671f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 0f)
                horizontalLineTo(5f)
                verticalLineTo(4f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(5f)
                verticalLineTo(9f)
                horizontalLineTo(6f)
                verticalLineTo(5f)
                horizontalLineTo(11f)
                verticalLineTo(4f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.063f, 0f)
                horizontalLineTo(6.938f)
                verticalLineTo(3.063f)
                lineTo(11f, 3f)
                verticalLineTo(5.875f)
                lineTo(6.938f, 5.938f)
                verticalLineTo(9f)
                horizontalLineTo(4.063f)
                verticalLineTo(5.938f)
                lineTo(0f, 5.875f)
                verticalLineTo(3f)
                lineTo(4.063f, 3.063f)
                verticalLineTo(0f)
                close()
                moveTo(5f, 4f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(5f)
                verticalLineTo(9f)
                horizontalLineTo(6f)
                verticalLineTo(5f)
                horizontalLineTo(11f)
                verticalLineTo(4f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                horizontalLineTo(5f)
                verticalLineTo(4f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(4f, 1f)
                horizontalLineToRelative(15f)
                verticalLineToRelative(13f)
                horizontalLineToRelative(-15f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(5.92f, 12.278f)
                lineTo(5.1f, 13.036f)
                lineTo(5.181f, 11.922f)
                lineTo(4.077f, 11.754f)
                lineTo(4.999f, 11.123f)
                lineTo(4.442f, 10.155f)
                lineTo(5.51f, 10.482f)
                lineTo(5.92f, 9.443f)
                lineTo(6.33f, 10.482f)
                lineTo(7.398f, 10.155f)
                lineTo(6.841f, 11.123f)
                lineTo(7.763f, 11.754f)
                lineTo(6.659f, 11.922f)
                lineTo(6.74f, 13.036f)
                lineTo(5.92f, 12.278f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(13.24f, 8.297f)
                lineTo(12.693f, 8.802f)
                lineTo(12.747f, 8.059f)
                lineTo(12.012f, 7.947f)
                lineTo(12.626f, 7.526f)
                lineTo(12.255f, 6.881f)
                lineTo(12.967f, 7.099f)
                lineTo(13.24f, 6.407f)
                lineTo(13.513f, 7.099f)
                lineTo(14.225f, 6.881f)
                lineTo(13.854f, 7.526f)
                lineTo(14.468f, 7.947f)
                lineTo(13.733f, 8.059f)
                lineTo(13.787f, 8.802f)
                lineTo(13.24f, 8.297f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(14.52f, 2.963f)
                lineTo(13.973f, 3.469f)
                lineTo(14.027f, 2.726f)
                lineTo(13.292f, 2.614f)
                lineTo(13.906f, 2.193f)
                lineTo(13.535f, 1.548f)
                lineTo(14.247f, 1.766f)
                lineTo(14.52f, 1.073f)
                lineTo(14.793f, 1.766f)
                lineTo(15.505f, 1.548f)
                lineTo(15.134f, 2.193f)
                lineTo(15.748f, 2.614f)
                lineTo(15.013f, 2.726f)
                lineTo(15.067f, 3.469f)
                lineTo(14.52f, 2.963f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(17.72f, 5.63f)
                lineTo(17.173f, 6.135f)
                lineTo(17.227f, 5.393f)
                lineTo(16.492f, 5.28f)
                lineTo(17.106f, 4.86f)
                lineTo(16.735f, 4.214f)
                lineTo(17.447f, 4.432f)
                lineTo(17.72f, 3.74f)
                lineTo(17.993f, 4.432f)
                lineTo(18.705f, 4.214f)
                lineTo(18.334f, 4.86f)
                lineTo(18.948f, 5.28f)
                lineTo(18.213f, 5.393f)
                lineTo(18.267f, 6.135f)
                lineTo(17.72f, 5.63f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(15.16f, 13.297f)
                lineTo(14.613f, 13.802f)
                lineTo(14.667f, 13.059f)
                lineTo(13.932f, 12.947f)
                lineTo(14.546f, 12.526f)
                lineTo(14.175f, 11.881f)
                lineTo(14.887f, 12.099f)
                lineTo(15.16f, 11.407f)
                lineTo(15.433f, 12.099f)
                lineTo(16.145f, 11.881f)
                lineTo(15.774f, 12.526f)
                lineTo(16.388f, 12.947f)
                lineTo(15.653f, 13.059f)
                lineTo(15.707f, 13.802f)
                lineTo(15.16f, 13.297f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(17.4f, 9.139f)
                lineTo(16.844f, 9.431f)
                lineTo(16.951f, 8.813f)
                lineTo(16.501f, 8.375f)
                lineTo(17.122f, 8.284f)
                lineTo(17.4f, 7.722f)
                lineTo(17.678f, 8.284f)
                lineTo(18.299f, 8.375f)
                lineTo(17.849f, 8.813f)
                lineTo(17.955f, 9.431f)
                lineTo(17.4f, 9.139f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun HeardIslandAndMcdonaldIslandsPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.HeardIslandAndMcdonaldIslands,
            contentDescription = "Heard Island and McDonald Islands Flag"
        )
    }
}
